import {
  Button,
  Form,
  InputTextField,
  Loading,
  Spacer,
  TextLargeParagraphTitle,
} from '@carboncopyco/ui';
import { getMMMDYYYYathmmA } from '@carboncopyco/utils';
import { object } from 'yup';

export interface SaveRecordProps {
  onCancel: () => void;
  submitForm: (data: any) => any;
  isLoading: boolean;
}

export const newRecordingSchema = object({}).required();

export const UpdateRecording = ({
  onCancel,
  submitForm,
  isLoading,
}: SaveRecordProps) => {
  const initialValues = {
    description: `Updated clone on ${getMMMDYYYYathmmA()}`,
  };

  return (
    <div style={{ width: '300px' }}>
      <Form
        enableReinitialize
        onSubmit={submitForm}
        initialValues={initialValues}
        validationSchema={newRecordingSchema}
      >
        <>
          <TextLargeParagraphTitle
            color="text-ds-natural-600"
            label="Update clone?"
          />
          <Spacer amount={4} />
          <InputTextField
            label="Describe your changes"
            name="description"
            multiline
          />
          <Spacer amount={4} />
          <div className="w-full flex justify-end">
            <Button
              label="Cancel"
              link
              onClick={onCancel}
            />
            <Spacer />
            <Button
              label="Save clone"
              submit
              leftIcon={
                isLoading ? <Loading color="text-current" /> : undefined
              }
              disabled={isLoading}
            />
          </div>
          <Spacer amount={1} />
        </>
      </Form>
    </div>
  );
};
